module.exports = __webpack_public_path__ + "static/Sonyax50-602e9bceec55a0127a373e5ff56aaa9e.png";